import React from 'react';

import EmptyList from 'components/EmptyList';
import useStoreTranslation from 'hooks/useStoreTranslation';

const GroupEmptyList = () => {
  const { t } = useStoreTranslation();
  return (
    <EmptyList
      grey
      paddingMessage={54}
      title={t('groupList.emptyView.title')}
      description={t('groupList.emptyView.text')}
      image="/corporate/images/group-2.svg"
      backgroundImage="/corporate/images/group-3.svg"
    />
  );
};

export default GroupEmptyList;
